import { setResponseRejectedHandler } from "@/shared";

import { handleResponseRejected } from "./handleResponseRejected";

export const setResponseInterceptor = () => {
    setResponseRejectedHandler(handleResponseRejected);
};
